import Vue from "vue";
import Router from "vue-router";
import Work from "./views/work/index";
import subviews from "./views/work/subviews/index";
import store from "./store/index";
const load = (...p) => {
    return () =>
        import(`./views/${p[0]}/${p[1] || "index"}.vue`);
};
Vue.use(Router);


const Department = () => import('./views/userManager/department/Index.vue')
const ssv = () => import('./views/userManager/ssv/index.vue')
const detail = () => import('./views/userManager/ssv/detail.vue')
const regfee = () => import('./views/userManager/regfee/index.vue')
const regfeeDetail = () => import('./views/userManager/regfee/detail.vue')
const Manager = () => import('./views/userManager/manager/Index.vue')
const Auth = () => import('./views/userManager/auth/Index.vue')
const vueRouter = new Router({
    routes: [
        {
            path: window.location.host.indexOf("localhost") > -1 || window.location.host.indexOf("ceshi.shequyun") > -1 || window.location.host.indexOf("py.shequyun") > -1 ? "/" : "/showProduct1",
            name: "showProduct1",
            component: load("showProduct1"),
            meta: {
                showDaohang: false,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: window.location.host.indexOf("localhost") > -1 || window.location.host.indexOf("ceshi.shequyun") > -1 || window.location.host.indexOf("py.shequyun") > -1 ? "/showProduct" : "/",
            name: "showProduct",
            component: load("showProduct"),
            meta: {
                showDaohang: false,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/dxdpjjfz",
            name: "dxdpjjfz",
            component: load("dxdpjjfz")
        },
        {
            path: "/dxdp",
            name: "dxdp",
            component: load("xsw")
        },
        {
            path: "/bbddp",
            name: "bbddp",
            component: load("banbidian")
        },
        {
            path: "/Xiaofeiquan",
            name: "Xiaofeiquan",
            component: load("Xiaofeiquan")
        },
        {
            path: "/Xiaofeiquan2",
            name: "Xiaofeiquan2",
            component: load("Xiaofeiquan2")
        },
        {
            path: "/Xiaofeiquan3",
            name: "Xiaofeiquan3",
            component: load("Xiaofeiquan3")
        },
        {
            path: "/Xiaofeiquan4",
            name: "Xiaofeiquan4",
            component: load("Xiaofeiquan4")
        },
        {
            path: "/Xiaofeiquan5",
            name: "Xiaofeiquan5",
            component: load("Xiaofeiquan5")
        },
        {
            path: "/Xiaofeiquan6",
            name: "Xiaofeiquan6",
            component: load("Xiaofeiquan6")
        },
        {
            path: "/NewLogin",
            name: "NewLogin",
            component: load("NewLogin"),
            meta: {
                showDaohang: false,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/PyChiefWaiterManageLogin",
            name: "PyChiefWaiterManageLogin",
            component: load("PyChiefWaiterManageLogin"),
            meta: {
                showDaohang: false,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/Register",
            name: "Register",
            component: load("Register"),
            meta: {
                showDaohang: false,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/AuditPage",
            name: "AuditPage",
            component: load("AuditPage"),
            meta: {
                showDaohang: false,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/Administrator",
            name: "Administrator",
            component: load("Administrator"),
            redirect: "/Administrator/basic",
            meta: {
                showDaohang: true,
                showLeftSideBar: true
            },
            children: [{
                path: "/Administrator/basic",
                name: "adminBasic",
                component: load("Administrator", "basic"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/Administrator/manage",
                name: "adminManage",
                component: load("Administrator", "manage"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: true
                }
            },
            {
                path: "/Administrator/jifen",
                name: "adminJifen",
                component: load("Administrator", "jifen"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/Administrator/setAuth",
                name: "setAuth",
                component: load("Administrator", "setAuth"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/Administrator/xfejAuth",
                name: "xfejAuth",
                component: load("Administrator", "xfejAuth"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/Administrator/setJf",
                name: "setJf",
                component: load("Administrator", "setJf"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/Administrator/miniProgram",
                name: "miniProgram",
                component: load("Administrator", "miniProgram"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/Administrator/webSetting",
                name: "webSetting",
                component: load("Administrator", "webSetting"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/Administrator/mstSet",
                name: "mstSet",
                component: load("Administrator", "mstSet"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/Administrator/bannerSet",
                name: "bannerSet",
                component: load("Administrator", "bannerSet"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/Administrator/modelSet",
                name: "modelSet",
                component: load("Administrator", "modelSet"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/Administrator/serviceSet",
                name: "serviceSet",
                component: load("Administrator", "serviceSet"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/Administrator/sysNotice",
                name: "sysNotice",
                component: load("Administrator", "sysNotice"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: false,
                    showFilter: false
                }
            },
            {
                path: "/Administrator/sysNotDetail",
                name: "sysNotDetail",
                component: load("Administrator", "sysNotDetail"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: false,
                    showFilter: false
                }
            }
            ]
        },
        {
            path: "/userManager",
            name: "userManager",
            component: load("userManager"),
            redirect: "/userManager/statistics",
            meta: {
                showDaohang: true,
                showLeftSideBar: true
            },
            children: [{
                path: "/userManager/userCitizen",
                name: "userCitizen",
                component: load("userManager", "userCitizen"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: true
                }
            },
            {
                path: "/userManager/statistics",
                name: "statistics",
                component: load("userManager", "statistics"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/department",
                name: "Department",
                component: Department,
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/auth",
                name: "Auth",
                component: Auth,
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/manager",
                name: "Manager",
                component: Manager,
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/vanguard",
                name: "vanguard",
                component: load("userManager", "vanguard"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/grid/gridMgt",
                name: "gridMgt",
                component: load("userManager/grid", "gridMgt"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: true
                }
            },
            {
                path: "/userManager/grid/detail",
                name: "gridDetail",
                component: load("userManager/grid", "gridDetail"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/grid/beauty",
                name: "beauty",
                component: load("userManager/grid", "beauty"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/grid/beautyEdit",
                name: "beautyEdit",
                component: load("userManager/grid", "beautyEdit"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/star",
                name: "star",
                component: load("userManager", "star"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/vanguardEdit",
                name: "vanguardEdit",
                component: load("userManager", "vanguardEdit"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/starEdit",
                name: "starEdit",
                component: load("userManager", "starEdit"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/userStatics",
                name: "userStatics",
                component: load("userManager", "userStatics"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/userCitizen/citizenDetail",
                name: "citizenDetail",
                component: load("userManager", "citizenDetail"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/userEnterprise",
                name: "userEnterprise",
                component: load("userManager", "userEnterprise"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: true
                }
            },
            {
                path: "/userManager/qiyeMap",
                name: "qiyeMap",
                component: load("userManager", "qiyeMap"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/qiyeTotal",
                name: "qiyeTotal",
                component: load("userManager", "qiyeTotal"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/qiyeDetail",
                name: "qiyeDetail",
                component: load("userManager", "qiyeDetail"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            }, {
                path: "/userManager/addFangyi",
                name: "addWorker",
                component: load("Shequ/fangyi", "add"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/fangyidetail",
                name: "qyWorkerDetail",
                component: load("Shequ/fangyi", "detail"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/userSocialWorker",
                name: "userSocialWorker",
                component: load("userManager", "userSocialWorker"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: true
                }
            },
            {
                path: "/userManager/userSocialWorker/workerDetail",
                name: "workerDetail",
                component: load("userManager", "workerDetail"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/organize",
                name: "organize",
                component: load("userManager", "organize"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: true
                }
            },
            {
                path: "/userManager/organizeDetail",
                name: "orgDetail",
                component: load("userManager", "organizeDetail"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/advert",
                name: "advert",
                component: load("userManager", "advert"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/resumptionStatistic",
                name: "resumptionStatistic",
                component: load("userManager", "resumptionStatistic"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/advertEdit",
                name: "advertEdit",
                component: load("userManager", "advertEdit"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: true,
                    showFilter: false
                }
            },
            {
                path: "/userManager/share",
                component: load("userManager/share", "index"),
                children: [
                    // using default router instead of redirect
                    {
                        path: "",
                        name: "shareList",
                        component: load("userManager/share", "list"),
                        meta: {
                            showDaohang: true,
                            showLeftSideBar: true
                        }
                    },
                    {
                        path: "publish",
                        name: "sharePublish",
                        component: load("userManager/share", "publish"),
                        meta: {
                            showDaohang: true,
                            showLeftSideBar: true
                        }
                    }
                ]
            }
            ]
        },
        /* ******************* 微支部 开始******************* */
        {
            path: "/miniParty",
            name: "miniParty",
            component: load("miniParty"),
            redirect: "/miniParty/list",
            meta: {
                showDaohang: true,
                showLeftSideBar: false,
                showFilter: false
            },
            children: [{
                path: "/miniParty/list",
                component: load("miniParty", "index-list"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: false,
                    showFilter: true,
                    showTab: true // 显示index页面的tab
                }
            },
            {
                path: "/miniParty/carousel",
                component: load("miniParty", "index-carousel"),
                meta: {
                    showDaohang: true,
                    showLeftSideBar: false,
                    showFilter: false,
                    showTab: true // 显示index页面的tab
                }
            },
            {
                name: "detail-index",
                path: "/miniParty/detail-index",
                component: load("miniParty", "detail-index"),
                meta: {
                    showDaohang: true
                },
                children: [{
                    name: "ddw",
                    path: "/miniParty/detail-index/ddw",
                    component: load("miniParty", "detail-ddw"),
                    meta: {
                        showDaohang: true
                    }
                },
                {
                    name: "ldb",
                    path: "/miniParty/detail-index/ldb",
                    component: load("miniParty", "detail-ldb"),
                    meta: {
                        showDaohang: true
                    }
                },
                {
                    name: "dzz",
                    path: "/miniParty/detail-index/dzz",
                    component: load("miniParty", "detail-dzz"),
                    meta: {
                        showDaohang: true
                    }
                }
                ]
            }
            ]
        },
        /* ******************* 微支部 结束******************* */
        {
            path: "/miniCommunity",
            component: load("miniCommunity", "index"),
            children: [{
                path: "",
                name: "miniCommunity",
                component: load("miniCommunity", "list"),
                meta: {
                    showDaohang: true,
                    showFilter: true
                }
            },
            {
                path: "gallery",
                name: "communityGallery",
                component: load("miniCommunity", "gallery"),
                meta: {
                    showDaohang: true
                }
            }
            ]
        },
        {
            path: "/miniCommunity/communityDetail",
            name: "communityDetail",
            component: load("miniCommunity", "communityDetail"),
            meta: {
                showDaohang: true,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/miniCommunity/ownCommitee",
            name: "ownCommitee",
            component: load("miniCommunity/ownCommitee", "ownCommitee"),
            meta: {
                showDaohang: true,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/miniCommunity/ownCommitee/detail",
            name: "ownCommitteeDetail",
            component: load("miniCommunity/ownCommitee", "ownCommitteeDetail"),
            meta: {
                showDaohang: true,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/miniCommunity/committee",
            name: "committee",
            component: load("miniCommunity", "committee"),
            meta: {
                showDaohang: true,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/work",
            name: "Work",
            component: Work,
            children: [{
                path: "subviews",
                component: subviews
            }]
        },
        {
            path: "/shouye",
            name: "Shouye",
            component: load("Shouye"),
            meta: {
                showDaohang: true,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/Shequ",
            name: "Shequ",
            component: load("Shequ"),
            redirect: "/Shequ/activitylist",
            meta: {
                showDaohang: true,
                showLeftSideBar: true
            },
            children: [
                {
                    path: "/Shequ/waterelectricity/indexs",
                    name: "waterelectricitys",
                    component: load("Shequ/waterelectricity", "indexs"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/waterelectricity/details",
                    name: "waterelectricitydetails",
                    component: load("Shequ/waterelectricity", "details"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/waterelectricity/index",
                    name: "waterelectricity",
                    component: load("Shequ/waterelectricity", "index"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/waterelectricity/detail",
                    name: "waterelectricitydetail",
                    component: load("Shequ/waterelectricity", "detail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/newStudents/index",
                    name: "index",
                    component: load("Shequ/newStudents", "index"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/newStudents/index1",
                    name: "index1",
                    component: load("Shequ/newStudents", "index1"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/newStudents/distributionRules",
                    name: "distributionRules",
                    component: load("Shequ/newStudents", "distributionRules"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/newStudents/pleasedel",
                    name: "pleasedel",
                    component: load("Shequ/newStudents", "pleasedel"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/newStudents/detail",
                    name: "newStudentsdetail",
                    component: load("Shequ/newStudents", "detail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/newStudents/reportlist",
                    name: "reportlist",
                    component: load("Shequ/newStudents", "reportlist"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/newStudents/educationlist",
                    name: "educationlist",
                    component: load("Shequ/newStudents", "educationlist"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/newStudents/schoollist",
                    name: "schoollist",
                    component: load("Shequ/newStudents", "schoollist"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/newborn",
                    name: "newborn",
                    component: load("Shequ/newBorn", "newborn"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/certification",
                    name: "certification",
                    component: load("Shequ/certification", 'index'),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/newStudents/fivesixinfo",
                    name: "fivesixinfo",
                    component: load("Shequ/newStudents", "fivesixinfo"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/newStudents/landnum",
                    name: "landnum",
                    component: load("Shequ/newStudents", "landnum"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/newStudents/landnumdetail",
                    name: "landnumdetail",
                    component: load("Shequ/newStudents", "landnumdetail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/newStudents/landnumadd",
                    name: "landnumadd",
                    component: load("Shequ/newStudents", "landnumadd"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/battlefield",
                    name: "battlefield",
                    component: load("Shequ/battlefield", "battlefield"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },

                {
                    path: "/Shequ/activityroom",
                    name: "activityroom",
                    component: load("Shequ/activityroom", "activityroom"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/newNotice",
                    name: "newNotice",
                    component: load("Shequ", "newNotice"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/eventQuery",
                    name: "eventQuery",
                    component: load("Shequ/event", "eventQuery"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/eventHandle",
                    name: "eventHandle",
                    component: load("Shequ/event", "eventHandle"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/eventNotice",
                    name: "eventNotice",
                    component: load("Shequ/event", "eventNotice"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/sqEventDetail",
                    name: "sqEventDetail",
                    component: load("Shequ/event", "sqEventDetail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/eventStatistics",
                    name: "eventStatistics",
                    component: load("Shequ/event", "eventStatistics"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/newVote",
                    name: "newVote",
                    component: load("Shequ/vote", "newVote"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/votelist",
                    name: "votelist",
                    component: load("Shequ/vote", "votelist"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/goldenPipsList",
                    name: "goldenPipsList",
                    component: load("Shequ/goldenPips", "goldenpipslist"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/voteDetail",
                    name: "voteDetail",
                    component: load("Shequ/vote", "voteDetail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                // {
                //   path: '/Shequ/assembly/:comeType',
                //   name: 'assembly',
                //   component: load('Shequ/assembly', 'assembly'),
                //   meta: {
                //     showDaohang: true,
                //     showLeftSideBar: true,
                //     showFilter: false
                //   }
                // },
                {
                    path: "/Shequ/assembly",
                    name: "assembly",
                    component: load("Shequ/assembly", "assembly"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/assembly/?comeType=11",
                    name: "juminAssembly",
                    component: load("Shequ/assembly", "assembly"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/assembly/?comeType=14",
                    name: "dangweiAssembly",
                    component: load("Shequ/assembly", "assembly"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/assemblyDetail",
                    name: "assemblyDetail",
                    component: load("Shequ/assembly", "assemblyDetail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/assemblyNew",
                    name: "assemblyNew",
                    component: load("Shequ/assembly", "assemblyNew"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/gonggao",
                    name: "gonggao",
                    component: load("Shequ/gonggao", "gonggao"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/newGonggao",
                    name: "newGonggao",
                    component: load("Shequ/gonggao", "newGonggao"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/sendHistory",
                    name: "sendHistory",
                    component: load("Shequ", "sendHistory"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/activitylist",
                    name: "activitylist",
                    component: load("Shequ/activity", "activityList"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: true,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/newactivity",
                    name: "newactivity",
                    component: load("Shequ/activity", "newActivity"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/activitydetail",
                    name: "activitydetail",
                    component: load("Shequ/activity", "activityDetail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/previewDetail",
                    name: "previewDetail",
                    component: load("Shequ", "previewDetail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/phone",
                    name: "bianminPhone",
                    component: load("Shequ", "bianminPhone"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/carManage",
                    name: "carManage",
                    component: load("Shequ/car", "carManage"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/carManageSetting",
                    name: "carManageSetting",
                    component: load("Shequ/car", "carManageSetting"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/pointsExchange",
                    name: "pointsExchange",
                    component: load("Shequ/exchange", "pointsExchange"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: true
                    }
                },
                {
                    path: "/Shequ/newExchange",
                    name: "newExchange",
                    component: load("Shequ/exchange", "newExchange"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/goodDetail",
                    name: "goodDetail",
                    component: load("Shequ/exchange", "goodDetail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/appointment/service",
                    name: "appointmentService",
                    component: load("Shequ", "appointmentService"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/appointment/record",
                    name: "appointmentRecord",
                    component: load("Shequ", "appointmentRecord"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/blacklist",
                    name: "blacklist",
                    component: load("Shequ", "blacklist"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/appointment/edit",
                    name: "appointmentEdit",
                    component: load("Shequ", "appointmentEdit"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/appointment/detail",
                    name: "appointmentDetail",
                    component: load("Shequ", "appointmentDetail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/fangyilist",
                    name: "fangyilist",
                    component: load("Shequ/fangyi", "list"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                }, {
                    path: "/Shequ/personInspection",
                    name: "personInspection",
                    component: load("Shequ/personInspection", "list"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/personInspection/detail",
                    name: "personInspectionDetail",
                    component: load("Shequ/personInspection", "detail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/fangyiStatistics",
                    name: "fangyiStatistics",
                    component: load("Shequ/fangyi", "epidemicStatistics"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                }, {
                    path: "/Shequ/addFangyi",
                    name: "addFangyi",
                    component: load("Shequ/fangyi", "add"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                }, {
                    path: "/Shequ/fangyidetail",
                    name: "fangyidetail",
                    component: load("Shequ/fangyi", "detail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                }, {
                    path: "/Shequ/fangyiSet",
                    name: "fangyiSet",
                    component: load("Shequ/fangyi", "set"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                }, {
                    path: "/Shequ/epidemicSet",
                    name: "epidemicSet",
                    component: load("Shequ/fangyi", "epidemicSet"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/epidemicNotice",
                    name: "epidemicNotice",
                    component: load("Shequ/fangyi", "epidemicNotice"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/epidemicForm",
                    name: "epidemicForm",
                    component: load("Shequ/fangyi/epidemicForm", "index"),
                    meta: {
                        showDaohang: false,
                        showLeftSideBar: false,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/epidemicPeopleCard",
                    name: "epidemicPeopleCard",
                    component: load("Shequ/fangyi", "epidemicPeopleCard"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/epidemicRemoval",
                    name: "epidemicRemoval",
                    component: load("Shequ/fangyi", "epidemicRemoval"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/peopleLibrary",
                    name: "peopleLibrary",
                    component: load("Shequ/fangyi", "peopleLibrary"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/addLibrary",
                    name: "addLibrary",
                    component: load("Shequ/fangyi", "addLibrary"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                }, {
                    path: "/Shequ/walkRecord",
                    name: "walkRecord",
                    component: load("Shequ/fangyi", "walkRecord"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                }, {
                    path: "/Shequ/healthRecord",
                    name: "healthRecord",
                    component: load("Shequ/fangyi", "healthRecord"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/yuyuelist",
                    name: "yuyuelist",
                    component: load("Shequ/yuyue", "yuyueList"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/domicile",
                    name: "domicile",
                    component: load("Shequ/domicile", "domicile"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/licensese",
                    name: "licensese",
                    component: load("Shequ/licensese", "licensese"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/addYuyue",
                    name: "addYuyue",
                    component: load("Shequ/yuyue", "addYuyue"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/yuyueSetting",
                    name: "yuyueSetting",
                    component: load("Shequ/yuyue", "yuyueSetting"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                }, {
                    path: "/Shequ/addRecord",
                    name: "addRecord",
                    component: load("Shequ/yuyue", "addRecord"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                }, {
                    path: "/Shequ/ssv",
                    name: "ssv",
                    component: ssv,
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/regfee",
                    name: "regfee",
                    component: regfee,
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/taxquery",
                    name: "taxQuery",
                    component: load("userManager/taxQuery", "taxQuery"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/birthCert",
                    name: "birthCert",
                    component: load("userManager/birthCert", "birthCert"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/marriageRegister",
                    name: "marriageRegister",
                    component: load("userManager/marriageRegister", "marriageRegister"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/rkMessVerification",
                    name: "rkMessVerification",
                    component: load("userManager/rkMessVerification", "rkMessVerification"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/swyxzmInfo",
                    name: "swyxzmInfo",
                    component: load("userManager/swyxzmInfo", "swyxzmInfo"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/mzbJjhfr",
                    name: "mzbJjhfr",
                    component: load("userManager/mzbJjhfr", "mzbJjhfr"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/businessEnquiries",
                    name: "businessEnquiries",
                    component: load("userManager/businessEnquiries", "businessEnquiries"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/enterpriseValidation",
                    name: "enterpriseValidation",
                    component: load("userManager/enterpriseValidation", "enterpriseValidation"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/qyjjjfpjxx",
                    name: "qyjjjfpjxx",
                    component: load("userManager/qyjjjfpjxx", "qyjjjfpjxx"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/qyjjjfpjxx",
                    name: "qyjjjfpjxx",
                    component: load("userManager/qyjjjfpjxx", "qyjjjfpjxx"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/regfee/detail",
                    name: "regfeeDetail",
                    component: regfeeDetail,
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/allowance/apply",
                    name: "apply",
                    component: load("Shequ/allowance", "apply"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/allowance/applyDetail",
                    name: "applyDetail",
                    component: load("Shequ/allowance", "applyDetail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/allowance",
                    name: "allowance",
                    component: load("Shequ/allowance", "list"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/dataCollection/maintenance",
                    name: "maintenance",
                    component: load("Shequ/dataCollection/maintenance", "maintenance"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/dataCollection/maintenance/detail",
                    name: "maintenanceDetail",
                    component: load("Shequ/dataCollection/maintenance", "detail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/dataCollection/companyInfo",
                    name: "companyInfo",
                    component: load("Shequ/dataCollection/companyInfo", "companyInfo"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/dataCollection/companyInfo/detail",
                    name: "companyInfoDetail",
                    component: load("Shequ/dataCollection/companyInfo", "detail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/dataCollection/generalChange",
                    name: "generalChange",
                    component: load("Shequ/dataCollection/generalChange", "index"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/dataCollection/generalChange/detail",
                    name: "generalChangeDetail",
                    component: load("Shequ/dataCollection/generalChange", "detail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/dataCollection/priceDifference",
                    name: "priceDifference",
                    component: load("Shequ/dataCollection/priceDifference", "priceDifference"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/dataCollection/maintenance/detail",
                    name: "priceDifferenceDetail",
                    component: load("Shequ/dataCollection/priceDifference", "detail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/dataCollection/landTransfer",
                    name: "landTransfer",
                    component: load("Shequ/dataCollection/landTransfer", "landTransfer"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/dataCollection/landTransfer/detail",
                    name: "landTransferDetail",
                    component: load("Shequ/dataCollection/landTransfer", "detail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/dataCollection/promiseBook",
                    name: "promiseBook",
                    component: load("Shequ/dataCollection/promiseBook", "index"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/dataCollection/promiseBookDetail",
                    name: "promiseBookDetail",
                    component: load("Shequ/dataCollection/promiseBook", "detailFile"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/dataCollection/commitment",
                    name: "commitment",
                    component: load("Shequ/dataCollection/promiseBook", "index1"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/dataCollection/commitmentDetail",
                    name: "commitmentDetail",
                    component: load("Shequ/dataCollection/promiseBook", "detailFile1"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {

                    path: "/Shequ/dataCollection/fileLetter",
                    name: "fileLetter",
                    component: load("Shequ/dataCollection/fileLetter", "index"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/dataCollection/promiseFile",
                    name: "promiseFile",
                    component: load("Shequ/dataCollection/promiseFile", "index"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/dataCollection/taxInfo",
                    name: "taxInfo",
                    component: load("Shequ/dataCollection/taxInfo", "taxInfo"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/dataCollection/taxInfo/detail",
                    name: "taxInfoDetail",
                    component: load("Shequ/dataCollection/taxInfo", "detail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/dataCollection/dutyFree",
                    name: "dutyFree",
                    component: load("Shequ/dataCollection/dutyFree", "dutyFree"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/dataCollection/dutyFree/detail",
                    name: "dutyFreeDetail",
                    component: load("Shequ/dataCollection/dutyFree", "detail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/dataCollection/stampDuty",
                    name: "stampDuty",
                    component: load("Shequ/dataCollection/stampDuty", "stampDuty"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/dataCollection/stampDuty/detail",
                    name: "stampDutyDetail",
                    component: load("Shequ/dataCollection/stampDuty", "detail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/dataCollection/divorceAgreement",
                    name: "divorceAgreement",
                    component: load("Shequ/dataCollection/divorceAgreement", "divorceAgreement"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/dataCollection/divorceAgreement/detail",
                    name: "divorceAgreementDetail",
                    component: load("Shequ/dataCollection/divorceAgreement", "detail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/contract",
                    name: "contract",
                    component: load("Shequ/contract", "contract"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/mailList",
                    name: "mailList",
                    component: load("Shequ/mailList", "mailList"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/mailList/detail",
                    name: "mailListDetail",
                    component: load("Shequ/mailList", "mailListDetail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/ssv/detail",
                    name: "ssvDetail",
                    component: detail,
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/sanitation",
                    name: "sanitation",
                    component: load("Shequ/sanitation", "sanitation"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/chiefWaiter",
                    name: "waiterManager",
                    component: load("Shequ/chiefWaiter", "waiterManager"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/chiefWaiter/detail",
                    name: "waiterManagerDetail",
                    component: load("Shequ/chiefWaiter", "waiterManagerDetail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/chiefWaiter/moreDetail",
                    name: "waiterManagerMoreDetail",
                    component: load("Shequ/chiefWaiter", "waiterManagerMoreDetail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/chiefWaiter/documentaryWork",
                    name: "documentaryWork",
                    component: load("Shequ/chiefWaiter", "documentaryWork"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/chiefWaiter/add",
                    name: "addChiefWaiter",
                    component: load("Shequ/chiefWaiter", "addChiefWaiter"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/chiefWaiter/recordStatistic",
                    name: "recordStatistic",
                    component: load("Shequ/chiefWaiter", "recordStatistic"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/chiefWaiter/questionList",
                    name: "questionList",
                    component: load("Shequ/chiefWaiter", "questionList"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/chiefWaiter/workQuestionList",
                    name: "workQuestionList",
                    component: load("Shequ/chiefWaiter", "workQuestionList"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/chiefWaiter/evaluateStatistic",
                    name: "evaluateStatistic",
                    component: load("Shequ/chiefWaiter", "evaluateStatistic"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/chiefWaiter/workSpecialClasses",
                    name: "workSpecialClasses",
                    component: load("Shequ/chiefWaiter", "workSpecialClasses"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/leaseContract",
                    name: "leaseContract",
                    component: load("Shequ/leaseContract"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: true,
                    }
                },
                {
                    path: "/Shequ/leaseContract/detail",
                    name: "leaseContractDetail",
                    component: load("Shequ/leaseContract", "detail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: false,
                    }
                },
                {
                    path: "/Shequ/printNO",
                    name: "printNO",
                    component: load("Shequ/printNO"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: false,
                    }
                },
                {
                    path: "/Shequ/printCertificate",
                    name: "printCertificate",
                    component: load("Shequ/printCertificate"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: false,
                    }
                },
                {
                    path: "/Shequ/printCertificate/detail",
                    name: "printCertificateDetail",
                    component: load("Shequ/printCertificate", "detail"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false,
                        keepAlive: false,
                    }
                },
                {
                    path: "/Shequ/communityReportList",
                    name: "communityReportList",
                    component: load("Shequ/report", "communityReportList"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/scoreManage",
                    name: "scoreManage",
                    component: load("Shequ/score", "manage"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/communityRegistrants",
                    name: "communityRegistrants",
                    component: load("Shequ/report", "communityRegistrants"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/activityHandleList",
                    name: "activityHandleList",
                    component: load("Shequ/ActivityHandle", "list"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                {
                    path: "/Shequ/PointsDeclare",
                    name: "PointsDeclare",
                    component: load("Shequ/Points", "Declare"),
                    meta: {
                        showDaohang: true,
                        showLeftSideBar: true,
                        showFilter: false
                    }
                },
                // {
                //     path: "/Shequ/shuzijingjifazhan",
                //     name: "shuzijingjifazhan",
                //     component: load("Shequ/shuzijingjifazhan", "index"),
                //     meta: {
                //         showDaohang: true,
                //         showLeftSideBar: true,
                //         showFilter: false,
                //         keepAlive:true,
                //     }
                // },
                // {
                //     path: "/Shequ/shuzijingjifazhan/detail",
                //     name: "shuzijingjifazhanDetail",
                //     component: load("Shequ/shuzijingjifazhan", "detail"),
                //     meta: {
                //         showDaohang: true,
                //         showLeftSideBar: true,
                //         showFilter: false
                //     }
                // }
            ]
        },
        {
            path: "/showActivity",
            name: "ActivityShow",
            component: load("showPage", "activity"),
            meta: {
                showDaohang: true,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/showEvents",
            name: "EventsShow",
            component: load("showPage", "events"),
            meta: {
                showDaohang: true,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/showNotice",
            name: "noticeShow",
            component: load("showPage", "notice"),
            meta: {
                showDaohang: true,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/weizhibu",
            name: "weizhibu",
            component: load("showPage", "weizhibu"),
            meta: {
                showDaohang: true,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/weishequ",
            name: "weishequ",
            component: load("showPage", "weishequ"),
            meta: {
                showDaohang: true,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/shequgonggao",
            name: "shequgonggao",
            component: load("showPage", "shequgonggao"),
            meta: {
                showDaohang: true,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/shijianbanli",
            name: "shijianbanli",
            component: load("showPage", "shijianbanli"),
            meta: {
                showDaohang: true,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/shequhuodong",
            name: "shequhuodong",
            component: load("showPage", "shequhuodong"),
            meta: {
                showDaohang: true,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/monitor",
            name: "monitor",
            component: load("monitor"),
            meta: {
                showDaohang: false,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/monitor/congtai",
            name: "CTmonitor",
            component: load("monitor", "congtaiMonitor"),
            meta: {
                showDaohang: false,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/test",
            name: "test",
            component: load("test", "test"),
            meta: {
                showDaohang: false,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/moduleList",
            name: "moduleList",
            component: load("moduleList", "index"),
            meta: {
                showDaohang: false,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/pymonitor",
            name: "pymonitor",
            component: load("monitorpy"),
            meta: {
                showDaohang: false,
                showLeftSideBar: false,
                showFilter: false
            }
        },
        {
            path: "/ctxfmonitor",
            name: "ctxfmonitor",
            component: load("monitorctxf"),
            meta: {
                showDaohang: false,
                showLeftSideBar: false,
                showFilter: false
            }
        },
    ]
});

// let allowBack = true
vueRouter.beforeEach(async (to, from, next) => {
    // 处理活动列表页 右侧筛选框  社区不显示  街道显示
    if (to.name == "activitylist" && sessionStorage.isJiedao == 0) {
        to.meta.showFilter = false;
    }
    var navigatorList = JSON.parse(store.state.navigatorList);
    var path = to.fullPath.split("/")[1];
    var change = 0;
    navigatorList.forEach((item, index) => {
        if (item.url.indexOf(path) > -1) {
            change = 1;
            store.commit("updateNavindex", index);
        }
    });
    if (change == 0) store.commit("updateNavindex", "999");

    next();
});

vueRouter.afterEach((to, from) => {
    // 处理从组织进入新建活动  更新左侧列表索引
    if (to.name == "newactivity" || to.name == "activitydetail") {
        store.state.sideIndex = 0;
    }
    // 处理从新建活动返回组织  更新左侧对应列表索引值
    if (to.name == "orgDetail") {
        store.state.sideIndex = 4;
    }
});
export default vueRouter;
